import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AssessmentmanagerService } from 'src/app/services/assessments/assessmentmanager.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ToastrService } from 'ngx-toastr';

declare var $;
@Component({
  selector: 'app-assessment-marksheet',
  templateUrl: './assessment-marksheet.component.html',
  styleUrls: ['./assessment-marksheet.component.css']
})
export class AssessmentMarksheetComponent implements OnInit {

  assessmentID:number;
  classID:number;
  batchID:number;
  dataTable: any;
  dtOptions: any;
  tableData = [];
  loadFailed = false;
  @ViewChild('dataTable', {static: true}) table;

  constructor( private assessmentmanager : AssessmentmanagerService , private router : Router ,private header : ComponentheaderService, private activatedroute : ActivatedRoute, private toastr : ToastrService) {

    this.assessmentID = this.activatedroute.snapshot.queryParams.aid;
    this.classID = this.activatedroute.snapshot.queryParams.classid;
    this.batchID = this.activatedroute.snapshot.queryParams.batchid;


  }

  ngOnInit(): void {
    this.header.pageLoadingStarted(this);

    this.assessmentmanager.getAssessmentBreadCrumb(this.assessmentID).toPromise().then(
      (response:any)=>{
        this.header.setHeaderDisplay( ` ${response.assessmentName}:`,
        [
          {
            displaytext: 'School',
            route: `/user/schoolhome`,
            params: { schoolID: response.schoolID }
          },
          {
            displaytext: 'Course',
            route: `/user/moduledetails`,
            params: { moduleID: response.moduleID }
          },
          {
            displaytext: 'Lesson' ,
            route: `/user/lesson`,
            params: { classid: this.classID }
          },
          {
            displaytext: "Assessments",
            route: `/user/assessmentconsole`,
            params: { classid: this.classID,batchid:this.batchID }
          },
          {
            displaytext: response.assessmentName,
            route: `/user/assessmentdetails`,
            params: { classid: this.classID,batchid:this.batchID, aid: response.assessmentID },
          },
          {
            displaytext: "Marksheet",
            route: `/user/assessmentmarksheet`,
            params: { classid: this.classID, aid: this.assessmentID }
          },
        ],
        []);

      }
    );
    this.getDataFromSource();


  }

  getDataFromSource() {
    this.assessmentmanager.getAssessmentMarksheet(this.assessmentID,this.batchID).subscribe(
      (response:any)=>{
        this.tableData = response.data.items;
        this.dtOptions = {
          data: this.tableData,
          columns: [
            {title: 'S/No', data: 'count'},
            {title: 'Student', data: 'name'},
            {title: 'Score', data: 'score'}
          ],
          dom: 'Bfrtip',
            // Configure the buttons
            buttons: [
              'excel'
            ]
        };
      },
      // The error handler was empty and pageLoadingDone was only called on success, so a failed
      // request left the page on its loading state for ever with nothing said. `complete` also
      // still ran and built the grid from an undefined config.
      (err: any) => {
        console.error(err);
        this.loadFailed = true;
        this.toastr.error(err?.error?.message || 'Unable to load the marksheet');
        this.header.pageLoadingDone(this);
      },
      () => {
        if (!this.dtOptions) { return; }
        this.dataTable = $(this.table.nativeElement);
        this.dataTable.DataTable(this.dtOptions);
        this.header.pageLoadingDone(this);
      }
     );

  }

}
